import Alerts from "components/modules/SingleDashboard/Alerts";
import Anomalies from "components/modules/SingleDashboard/Anomalies";
import DeviceUsers from "components/modules/SingleDashboard/DeviceUsers";
import { getDashboardNavItems } from "components/modules/SingleDashboard/helper";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AppsContainer from "../components/modules/Apps/AppsContainer";
import Fim from "../components/modules/Fim/Fim";
import SingleDashboard from "../components/modules/SingleDashboard/SingleDashboard";
import CustomNavTabs from "../components/shared/CustomNavTabs";
import { accessActions } from "../redux/slice/access.slice";
import { applicationsActions } from "../redux/slice/applications.slice";
import { authActions } from "../redux/slice/auth.slice";
import { packagesActions } from "../redux/slice/packages.slice";
import { uiActions } from "../redux/slice/ui.slice";
import { FETCH_GROUPS } from "../redux/types/group.types";
import { checkSinglePermission } from "components/shared/helper";
import { USER_PERMISSIONS } from "components/modules/Management/AccessManagement/helper";
import toast from "react-hot-toast";

const SingleDashboardPage = () => {
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedTab, setSelectedTab] = useState(0);

  const handleSelectedTab = (value) => {
    setSelectedTab(value);
  };

  useEffect(() => {
    if (userPermissions?.length && currentUser?.role) {
      if (!checkSinglePermission(USER_PERMISSIONS.VIEW_DEVICE_DETAILS, userPermissions, currentUser?.role)) {
        toast.error(" You do not have permission to view this page.");
        navigate("/devices");
      }
    }
  }, [userPermissions, currentUser?.role, navigate])

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: FETCH_GROUPS });
    dispatch(uiActions.actions.setSelectedNav(""));
  }, [dispatch, id, currentUser]);


  const applications = useSelector(
    applicationsActions.selectors.getApplications
  );
  const packages = useSelector(packagesActions.selectors.getPackages);

  const handleComponents = (tabIndex) => {
    const tabLabel = navItems[tabIndex]?.label;

    switch (tabLabel) {
      case "Dashboard":
        return <SingleDashboard />;
      case "Apps":
        return <AppsContainer applications={applications} packages={packages} />;
      case "Fim":
        return <Fim />;
      case "Alerts":
        return <Alerts />;
      case "Anomalies":
        return <Anomalies />;
      case "Users":
        return <DeviceUsers />;
      default:
        return <SingleDashboard />;
    }
  };


  const navItems = getDashboardNavItems({
    isAppsAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_INSTALLED_APPLICATIONS, userPermissions, currentUser?.role),
    isFimAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_FILE_INTEGRITY_MANAGEMENT, userPermissions, currentUser?.role),
    isAlertsAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ALERTS, userPermissions, currentUser?.role),
    isAnomaliesAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ANOMALIES, userPermissions, currentUser?.role),
    isDeviceUsersAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_DEVICE_USERS, userPermissions, currentUser?.role),
  })

  return (
    <div>
      <CustomNavTabs
        selectedTab={selectedTab}
        handleSelectedTab={handleSelectedTab}
        navItems={navItems}
      />
      {handleComponents(selectedTab)}
    </div>
  );
};

export default SingleDashboardPage;

